import { match } from 'ts-pattern';
import { tripleEquals } from './util/triple.js';
import { valuesHasRow } from './util/values.js';
import Processor from './index.js';
/**
 * Merges duplicate quad patterns.
 */
export class DuplicatePatternRemover extends Processor {
    processUnion(union) {
        // processes UNION patterns separately to prevent collapsing them into a single BGP
        return {
            ...union,
            patterns: union.patterns.map(this.processPattern.bind(this)),
        };
    }
    processPatterns(patterns) {
        const cleaned = [];
        for (const pattern of patterns) {
            match(pattern)
                .with({ type: 'bgp' }, bgp => {
                const triples = [];
                for (const triple of bgp.triples) {
                    // keep triple if it was not seen before in another BGP
                    if (!cleaned.some(bgpHasTriple(triple))) {
                        triples.push(triple);
                    }
                }
                if (triples.length) {
                    cleaned.push({
                        type: 'bgp',
                        triples,
                    });
                }
            })
                .with({ type: 'values' }, values => {
                const rows = [];
                for (const row of values.values) {
                    // keep row if it was not seen before in another VALUES
                    if (!cleaned.some(valuesHasRow(row))) {
                        rows.push(row);
                    }
                }
                if (rows.length) {
                    cleaned.push({
                        type: 'values',
                        values: rows,
                    });
                }
            })
                .otherwise(p => cleaned.push(p));
        }
        return super.processPatterns(mergeConsecutiveBGPs(cleaned));
    }
}
function mergeConsecutiveBGPs(patterns) {
    const merged = [];
    for (const pattern of patterns) {
        if (pattern.type === 'bgp') {
            const last = merged[merged.length - 1];
            if ((last === null || last === void 0 ? void 0 : last.type) === 'bgp') {
                merged[merged.length - 1] = {
                    type: 'bgp',
                    triples: last.triples.concat(pattern.triples),
                };
            }
            else {
                merged.push(pattern);
            }
        }
        else {
            merged.push(pattern);
        }
    }
    return merged;
}
function bgpHasTriple(triple) {
    return (pattern) => {
        return pattern.type === 'bgp' && pattern.triples.some(tripleEquals(triple));
    };
}
